import { connect } from 'react-redux';

import BarChartComponent from './../Components/BarChartComponent.jsx';
import { getHighlightedMetricImage } from './../reducers';
import { highlightBar } from './../actions';

const getLine = (image, type) => ({
  xAxisValue: `${image} ${type}`,
  color: 'purple'
});

export const mapStateToProps = (state, ownProps) => {
  const metricsInfo = ownProps.metricsInfo;
  const image = getHighlightedMetricImage(state);
  return {
    height: 100,
    title: ownProps.title,
    series: metricsInfo.series,
    data: metricsInfo.metrics,
    yMin: metricsInfo.min,
    yMax: metricsInfo.max,
    lines: image ? [
      getLine(image, 'NCF'),
      getLine(image, 'CCF')
    ] : [],
    noXDisplay: true,
    noTitle: true,
    noLegend: true
  };
};

export default connect(
  mapStateToProps,
  {
    onClick: (chart) => {
      chart._model.label = chart._model.label.slice(0, chart._model.label.length - 4);
      return highlightBar(chart);
    }
  }
)(BarChartComponent);


// WEBPACK FOOTER //
// src/Containers/BuildPageChartContainer.jsx